import { render, staticRenderFns } from "./FabricCreateEdit.vue?vue&type=template&id=46ed9ea9&scoped=true&"
import script from "./FabricCreateEdit.vue?vue&type=script&lang=js&"
export * from "./FabricCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./FabricCreateEdit.vue?vue&type=style&index=0&id=46ed9ea9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed9ea9",
  null
  
)

export default component.exports